import { ArrowInSquareIcon, ExportDataIcon } from "../../../images";
import { CustomButton } from "../../CustomButton";
import { AccountPlanModal } from "../../modal";
import { useState } from "react";
import { openLinkHandler } from "../../../../utils/openLinkHandler";
import { toast } from "react-toastify";
import { CustomToast } from "../../CustomToast";
import { getErrorMessage } from "../../../../utils/getErrorMessage";
import { useExportAccountPlansMutation } from "../../../../api";
import { AccountPlanStatus, PlaybookPlanNames } from "../../../../types/enums";
import { CircularProgress } from "@mui/material";
import { useAppSelector } from "../../../../hooks";
import { selectPermissions } from "../../../../features/permissionsSlice";
import { ReuseTooltip } from "../../ReuseTooltip";

const ExportAccountsPlanPDFBtn = ({
  account_id,
  campaign_id,
  hideButton = true,
  onClose,
  isSingleAccount,
  btnHeight = "36px",
  btnPadding = "6px",
}: {
  account_id?: string;
  campaign_id: string;
  hideButton?: boolean;
  onClose?: () => void;
  isSingleAccount?: boolean;
  btnHeight?: string;
  btnPadding?: string;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(hideButton);

  const { isAllowedExportAccountPlans } = useAppSelector(selectPermissions);

  const [exportAccountPlans, { isLoading }] = useExportAccountPlansMutation();

  const handleClose = () => {
    setIsOpen(false);
    onClose && onClose();
  };

  const submitHandler = (account_ids: string[], include_all: boolean) => {
    exportAccountPlans({
      campaign_id,
      account_ids,
      include_all,
    })
      .unwrap()
      .then((data) => {
        openLinkHandler(data.url, PlaybookPlanNames.account_plan);
        handleClose();
      })
      .catch((err) => {
        toast.error(
          <CustomToast
            type={"error"}
            text={
              getErrorMessage(err).globalError ||
              "Something went wrong. Please try again"
            }
            title={"Something went wrong"}
          />,
        );
      });
  };

  const onClickHandler = () => {
    if (isSingleAccount && account_id) {
      submitHandler([account_id], false);
    } else {
      setIsOpen(true);
    }
  };

  return (
    <>
      {!hideButton && (
        <ReuseTooltip
          text={`Export ${isSingleAccount ? PlaybookPlanNames.account_plan : PlaybookPlanNames.account_plans} (PDF)`}
        >
          <CustomButton
            onClick={onClickHandler}
            variant="outlined"
            customColor="#FFFFFF"
            textColor="#1D3E70"
            type="button"
            customSize="fit"
            style={{ padding: btnPadding }}
            sx={{
              borderColor: "#1D3E70",
              minWidth: "fit-content",
              height: btnHeight,
            }}
            disabled={isLoading || !isAllowedExportAccountPlans}
          >
            {isLoading ? (
              <CircularProgress size={24} sx={{ color: "#1C3C6C" }} />
            ) : isSingleAccount ? (
              <ExportDataIcon
                color={!isAllowedExportAccountPlans ? "#A5B2C6" : "#1D3E70"}
              />
            ) : (
              <ArrowInSquareIcon
                color={!isAllowedExportAccountPlans ? "#A5B2C6" : "#1D3E70"}
              />
            )}
          </CustomButton>
        </ReuseTooltip>
      )}

      {isOpen && (
        <AccountPlanModal
          title={`Export ${PlaybookPlanNames.account_plans} (PDF)`}
          description={`Which accounts would you like to create ${PlaybookPlanNames.account_plans} for?`}
          submitBtnText={`Export ${PlaybookPlanNames.account_plans}`}
          status_filter={AccountPlanStatus.completed}
          onClose={handleClose}
          isLoading={isLoading}
          onSubmit={submitHandler}
        />
      )}
    </>
  );
};
export default ExportAccountsPlanPDFBtn;
